import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { isExist } from "cxa-utils";
import { getPropsFromData, InputField, DATE_FORMAT } from "../../FormField";

const Employee = ({ data }) => {
  return (
    <fieldset>
      <h3>{"EMPLOYEE'S INFORMATION"}</h3>
      <section className="basicinfo display-flex-center">
        <div>
          <label htmlFor="EmployeeName">Name (According to NRIC / Passport)</label>
          <div className="field-container" id="RO_EmployeeName">
            <InputField {...getPropsFromData(data, "EmployeeName")} />
          </div>
        </div>
      </section>
      <section className="basicinfo display-flex-center">
        <div className="flex-auto-expand">
          <label htmlFor="Identification">NRIC / Passport / FIN Number</label>
          <div className="field-container" id="RO_Identification">
            <InputField {...getPropsFromData(data, "Identification")} />
          </div>
        </div>
        <div className="flex-auto-expand">
          <label htmlFor="Nationality">Nationality</label>
          <div className="field-container">
            <InputField {...getPropsFromData(data, "Nationality")} />
          </div>
        </div>
      </section>
      <section className="basicinfo display-flex-center">
        <div className="flex-auto-expand">
          <label htmlFor="Gender">Gender</label>
          <div className="field-container" id="RO_Gender">
            <InputField {...getPropsFromData(data, "Gender")} />
          </div>
        </div>
        <div className="flex-auto-expand">
          <label htmlFor="MaritalStatus">Marital Status</label>
          <div className="field-container" id="RO_MaritalStatus">
            <InputField {...getPropsFromData(data, "MaritalStatus")} />
          </div>
        </div>
        <div className="flex-auto-expand">
          <label htmlFor="BirthDate">Date of Birth (YYYY-MM-DD)</label>
          <div className="field-container" id="RO_BirthDate">
            <InputField
              {...getPropsFromData(data, "BirthDate")}
              format={value => isExist(value) && moment(value).format(DATE_FORMAT)}
            />
          </div>
        </div>
        <div className="flex-auto-expand">
          <div className="display-flex-center margin-top-bottom">
            <label htmlFor="Height" className="flex-auto-expand">
              Height(cm)
            </label>
            <div className="field-container flex-auto-expand margin-left">
              <InputField {...getPropsFromData(data, "Height")} />
            </div>
          </div>
          <div className="display-flex-center margin-top-bottom">
            <label htmlFor="Weight" className="flex-auto-expand">
              Weight(kg)
            </label>
            <div className="field-container flex-auto-expand margin-left">
              <InputField {...getPropsFromData(data, "Weight")} />
            </div>
          </div>
        </div>
        <div className="flex-auto-expand">
          <label htmlFor="ContactNumber">Contact Number</label>
          <div className="field-container" id="RO_ContactNumber">
            <InputField {...getPropsFromData(data, "ContactNumber")} />
          </div>
        </div>
      </section>
      <section className="basicinfo display-flex-center">
        <div>
          <label htmlFor="JobTitle">Occupation</label>
          <div className="field-container">
            <InputField {...getPropsFromData(data, "JobTitle")} />
          </div>
        </div>
      </section>
      <section className="basicinfo display-flex-center">
        <div>
          <label htmlFor="Email">Email Address</label>
          <div className="field-container">
            <InputField {...getPropsFromData(data, "Email")} />
          </div>
        </div>
      </section>
    </fieldset>
  );
};

Employee.propTypes = {
  data: PropTypes.object,
};

export default Employee;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/AIAHD201906/Employee.jsx